var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                model: _vm.inputForm,
                size: "small",
                disabled: _vm.method === "view",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                {
                  staticStyle: { "flex-wrap": "wrap" },
                  attrs: { gutter: 15, type: "flex" },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "英文值",
                            prop: "valEn",
                            rules: [
                              {
                                required: true,
                                message: "英文值不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              disabled: "",
                              placeholder: "请填写英文值",
                            },
                            model: {
                              value: _vm.inputForm.valEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "valEn", $$v)
                              },
                              expression: "inputForm.valEn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "中文值", prop: "valCn", rules: [] },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              disabled: "",
                              placeholder: "请填写中文值",
                            },
                            model: {
                              value: _vm.inputForm.valCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "valCn", $$v)
                              },
                              expression: "inputForm.valCn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "内容数值",
                            prop: "valNum",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: "",
                              placeholder: "请填写内容数值",
                            },
                            model: {
                              value: _vm.inputForm.valNum,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "valNum", $$v)
                              },
                              expression: "inputForm.valNum",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "字体大小",
                            prop: "fontSize",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写字体大小" },
                            model: {
                              value: _vm.inputForm.fontSize,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "fontSize", $$v)
                              },
                              expression: "inputForm.fontSize",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "字体类型",
                            prop: "fontFamily",
                            rules: [],
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                placeholder: "请填写字体类型",
                              },
                              on: { change: _vm.handCategories },
                              model: {
                                value: _vm.inputForm.fontFamily,
                                callback: function ($$v) {
                                  _vm.$set(_vm.inputForm, "fontFamily", $$v)
                                },
                                expression: "inputForm.fontFamily",
                              },
                            },
                            _vm._l(
                              _vm.$dictUtils.getDictList("cec_font_family"),
                              function (item) {
                                return _c("el-option", {
                                  key: item.labelEn,
                                  attrs: {
                                    label: item.labelEn,
                                    value: item.labelEn,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    size: "medium",
                    type: "danger",
                    icon: "el-icon-close",
                  },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: {
                        size: "medium",
                        type: "success",
                        icon: "el-icon-check",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }